import { Job as JobType, JobStatuses as JS} from './appUser';

export type Job = JobType;
export const JobStatuses = JS;

